import React from "react"
import ReactDOM from "react-dom"
import { BrowserRouter } from "react-router-dom"
import "reset-css"
import "typeface-open-sans"
import "typeface-roboto";
import App from "./App"
import "./index.css"
import "./theme-bridge.css"
import "./fonts.css"
import { ProvideCommunity } from "context/community";
import { PopupNotificationProvider } from "context/PopupNotificationProvider"
import { WebSocketProvider } from "context/realtime/webSocket"
import { OnlineStatusProvider } from "context/realtime/onlineStatus"
import { PermissionProvider } from "context/permissions"
import CommunityChatAssistant from "components/CommunityChatAssistant/CommunityChatAssistant";

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            <ProvideCommunity>
                <CommunityChatAssistant />
                <PermissionProvider>
                    <WebSocketProvider>
                        <OnlineStatusProvider>
                            <PopupNotificationProvider>
                                <App />
                            </PopupNotificationProvider>
                        </OnlineStatusProvider>
                    </WebSocketProvider>
                </PermissionProvider>
            </ProvideCommunity>
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById("app")
)